<div *ngIf="isValid$ | async;else invalidForm" #container>
  <div *ngIf="questionnaireGroupInfosListObs | async as questionnaireGroupInfosList;else loader" class="mx-auto py-2"
    style="max-width: 1200px;width: 100%;padding: 1rem;">
    <div class="card mb-2" *ngIf="titles[currentFormIndex]">
      <div class="card-body">
        <div class="bs-stepper">
          <div class="bs-stepper-header" role="tablist">
            <div class="step" *ngFor="let title of titles;let i = index">
              <button type="button" class="step-trigger" [class.active]="currentFormIndex === i" role="tab">
                <span class="bs-stepper-circle">{{i + 1}}</span>
                <span class="bs-stepper-label">{{titles[i]}}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <detail-info-form-page-steps *ngIf="questionnaireGroupInfosList" [showReset]="false" [multipleForms]="true"
      [(currentFormIndex)]="currentFormIndex" (formSubmit)="$event ? save($event): null"
      [detailGroupInfoList]="questionnaireGroupInfosList" [processing$]="processing$" [showCancel]="false">
      <div class="mb-1" recaptcha>
        <div class="g-recaptcha">
          <ng-container *ngIf="(captchaSiteKeyObs | async) as captchaSiteKey">
            <re-captcha name="recaptcha" required [siteKey]="captchaSiteKey" (resolved)="recaptchaResolved($event)">
            </re-captcha>
          </ng-container>
        </div>
      </div>
    </detail-info-form-page-steps>
  </div>
</div>
<ng-template #invalidForm>
  <h2 class="p-2 text-center">Something is wrong. Try again.</h2>
</ng-template>
<ng-template #loader>
  <app-loader></app-loader>
</ng-template>